module.exports = __webpack_public_path__ + "images/ebit2.jpg?ea94f7588dc70376adb4a9c901adc921";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/ebit2.jpg
// module id = 999
// module chunks = 0